import { render, staticRenderFns } from "./JcomConnectList.vue?vue&type=template&id=48457704"
import script from "./JcomConnectList.vue?vue&type=script&lang=js"
export * from "./JcomConnectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports